import { BuzonTipoNotificacionEnum } from '@/shared/types/interfaces/BuzonJudicial.interface';

/** Color del chip según el tipo de notificación (compartido por la tabla, el detalle y el aviso post-login). */
export const getNotificationTypeColor = (type: BuzonTipoNotificacionEnum): 'info' | 'warning' | 'success' => {
  if (type === BuzonTipoNotificacionEnum.DOCUMENTO) return 'info';
  if (type === BuzonTipoNotificacionEnum.CITACION) return 'warning';
  return 'success';
};

export const isValidUrl = (value: string): boolean => {
  if (!value) return false;
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

/** Fuerza la versión web de Teams cuando el enlace es de teams.microsoft.com. */
export const getTeamsWebUrl = (url: string) => {
  if (!url) return '';

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.hostname.includes('teams.microsoft.com')) {
      parsedUrl.searchParams.set('web', '1');
    }
    return parsedUrl.toString();
  } catch {
    return '';
  }
};

export const openTeamsWeb = (url: string) => {
  const teamsWebUrl = getTeamsWebUrl(url);
  if (!teamsWebUrl) {
    return;
  }

  window.open(teamsWebUrl, '_blank', 'noopener,noreferrer');
};
